<template>
  <div>
    <div class="part">
      <div class="r-main">
        <div class="part2">
          <div class="fjgz">
            <div class="fjgz_wrap boxshadow1">
              <div class="caption">{{$t('query.result.rules.addition.title')}}</div>
              <div class="cell">
                <div v-if="!_.isEmpty(dataSet.additional)">
                  <Collapse :value="dataSet.additional[0].name">
                    <Panel :name="item.name" v-for="(item, index) in dataSet.additional" :key="index">
                      <span class="prop_name">{{item.name}}</span>
                      <p slot="content">{{item.name}}：{{item.description}}</p>
                    </Panel>
                  </Collapse>
                  <!-- <Row :gutter="15">
                    <Col span="6" :class="['ellipsis', 'card-title', {active: item.id === currentAdditional.id}]" v-for="(item, index) in dataSet.additional" :key="`rule-add-${index}`">
                      <span :_id="item.id" @click="changeAdditional($event)">{{item.name}}</span>
                    </Col>
                  </Row>
                  <div class="card-content" ref="additionalContent"><span>{{currentAdditional.name}}</span>：{{currentAdditional.description}}</div> -->
                </div>
                <div class="nodata" v-else>暂无数据</div>
              </div>
            </div>
          </div>
          <div class="ysgz">
            <div class="ysgz_wrap boxshadow1">
              <div class="caption">{{$t('query.result.rules.transport.title')}}</div>
              <div class="cell scrolly">
                <div class="simple-text" v-if="!_.isEmpty(_.trim(dataSet.transportation))" v-html="$options.filters.transportationConver(dataSet.transportation)"></div>
                <div class="nodata" v-else>暂无数据</div>
              </div>
            </div>
          </div>
        </div>

        <div class="part3">
          <div class="danzen">
            <div class="danzen_wrap boxshadow1">
              <div class="caption">{{$t('query.result.rules.doc.title')}}</div>
              <div class="cell">
                <Row :gutter="15" v-if="!_.isEmpty(dataSet.document)" class="card-image-viewer" v-viewer>
                  <Col span="6" class="card-image" v-for="(item, index) in dataSet.document" :key="`rule-doc-${index}`">
                    <div class="card-image-wrap">
                      <div class="card-image-item">
                        <img :src="item.sampleFile">
                        <div class="glass"></div>
                      </div>
                      <p :_index="index" class="ellipsis" :title="item.fileName" style="cursor:pointer" @click="showImage">{{item.fileName}}</p>
                    </div>
                  </Col>
                </Row>
                <div class="nodata" style="margin-bottom:20px;" v-else>暂无数据</div>
              </div>
            </div>
          </div>
          <div class="news">
            <div class="news-wrap boxshadow1">
              <div class="caption">协定文本<span v-if="dataSet.id" class="more" @click="$router.push({path: '/down?id=' + dataSet.id + '&name=' + dataSet.name  })">更多<svg-icon icon-class="arrow2"></svg-icon></span></div>
              <div class="cell scrolly">
                <RelatedNews :listdata="listdata"></RelatedNews></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import RulesSider from './RulesSider'
import Velocity from 'velocity-animate'
// eslint-disable-next-line
import VelocityUI from 'velocity-animate/velocity.ui'
import RelatedNews from './zh-CN/News'

export default {
  name: 'RulesContent',
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    ranks: {
      type: Array,
      default: () => [],
      required: false
    }
  },
 
  components: { RulesSider, RelatedNews },

  data () {
    return {
      listdata:[],
  
      currentAdditional: this._.isEmpty(this.dataSet.additional) ? null : this.dataSet.additional[0]
    }
  },
 async created(){
  if(this.dataSet && this.dataSet.id){
    let response = await  this.$api.query.getKnowledgeNameByFtaId(this.dataSet.id);
    if (response.data.code === 200) {
    
         this.listdata =  response.data.data;
          
           
    } 

  }
    

  },

  watch: {
    async  dataSet  (newVal, oldVal) {
      if (newVal && !this._.isEmpty(newVal.additional)) {
        this.currentAdditional = newVal.additional[0]
      }
    
    }
  },
  methods: {
    changeAdditional (event) {
      let id = event.target.getAttribute('_id')
      let additional = this._.find(this.dataSet.additional, {'id': parseInt(id)})
      if (additional) {
        Velocity(this.$refs.additionalContent, { opacity: 0 }, {
          duration: 200,
          complete: () => {
            this.currentAdditional = additional
            Velocity(this.$refs.additionalContent, {opacity: 1}, {
              duration: 200,
              delay: 50,
              complete: () => {
                setTimeout(() => { this.refresh() }, 500)
              }
            })
          }
        })
      }
    },
    showImage (event) {
      let index = event.target.getAttribute('_index')
      const item = this.$el.querySelector('.card-image-viewer')
      if (item) {
        item.$viewer.view(parseInt(index) || 0)
      }
    },
    refresh () {
      this.$refs.sider && this.$refs.sider.refresh()
    }
  },
  filters: {
    transportationConver (value) {
      value = Vue._.trim(value)
      if (!value) return ''
      value = Vue._.replace(value, /\t/gm, Vue._.repeat('&nbsp;', 8))
      // value = Vue._.replace(value, /\s/gm, '&nbsp;')
      let items = Vue._.split(value, /(\n|\r|\n\r|\r\n|↵)/gm)
      items = Vue._.filter(items, (v) => {
        v = Vue._.trim(Vue._.replace(v, '↵', ''))
        return !Vue._.isEmpty(v)
      })
      items = Vue._.map(items, (v) => {
        return Vue._.replace(v, /\s/gm, '&nbsp;')
      })
      items = Vue._.map(items, (v) => {
        // v = Vue._.replace(Vue._.trim(v), /^[（\\[(【][一二三四五六七八九十1-9]+?[）\])】]\.?/gm, '<span style="left:0">$&</span>')
        // v = Vue._.replace(Vue._.trim(v), /^(&nbsp;)*([1-9]+?\.?)/gm, '<span style="left:0">$2</span>')
        return `<p>${Vue._.trim(v)}</p>`
      })
      return Vue._.join(items, '')
    }
  }
}
</script>
<style scoped>
  .part{
    position: relative;
    margin-bottom: 12px;
  }
  .part:last-child{
    margin-bottom: 0;
  }
  .r-main{}
  .r-main .desc{
    color: #999;
    /*font-size: 1.1rem;*/
    font-size: 1.3rem;
    font-weight: normal;
    padding-left: 10px;
  }
  .r-main p.desc{
    margin-top: 5px;
    padding-left: 0;
  }
  .r-main .caption .desc{
    padding-left: 20px;
  }
  .number-list{
    font-size: 14px;
    color: #333;
  }
  .number-list li{
    margin-bottom: 15px;
    position: relative;
    padding-left: 22px;
  }
  .number-list li:last-child{
    margin-bottom: 0;
  }
  .number-list .sn{
    background-color: #1F8AFD;
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 100px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-right: 5px;
    position: absolute;
    top: 2px;
    left: 0;
  }
  .card-title{
    margin-bottom: 15px;
  }
  .card-title span{
    background: url("~@/assets/images/icons/show/bulb.png") 0 center no-repeat transparent;
    background-size: 7px 10px;
    padding-left: 12px;
    /*font-size: 1.2rem;*/
    font-size: 1.4rem;
    position: relative;
    cursor: pointer;
  }
  .card-title.active span{
    color: #1F8AFD;
    background-image: url("~@/assets/images/icons/show/bulb_active.png");
  }
  .card-content{
    padding: 12px 20px;
    /*color: #2A2A2A;*/
    color: #999;
    /*font-size: 1.1rem;*/
    font-size: 1.3rem;
    line-height: 22px;
    background-color: #F9F9F9;
  }
  .card-content span{
    color: #333;
  }
  .simple-text{
    color: #666;
    /*font-size: 10px;*/
    font-size: 12px;
    word-break: break-all;
    word-wrap: break-word;
  }
  .simple-text >>> p{
    margin-bottom: 5px;
    position: relative;
    line-height: 26px;
  }
  .simple-text >>> p:last-child{
    margin-bottom: 0;
  }
  .simple-text >>> p span{
    position: absolute;
    top:0;
  }
  .card-image{
    margin-bottom: 15px;
  }
  .card-image .card-image-wrap{
    max-width: 145px;
  }
  .card-image .card-image-item{
    position: relative;
    cursor: pointer;
  }
  .card-image .card-image-item img{
    height: 150px;
    width: 100%;
  }
  .card-image .card-image-item:hover .glass{
    display: block;
  }
  .card-image .card-image-item .glass{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;
    display: none;
    background: url("~@/assets/images/icons/show/glass.png") center center no-repeat rgba(0, 0, 0, 0.3);
    background-size: 13px auto;
  }
  .card-image p{
    text-align: center;
    margin-top: 10px;
    color: #333;
    font-size: 14px;
  }
  .r-sidebar{
    position: absolute;
    top:0;
    right: 0;
    width: 220px;
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
  }
  section{
    background-color: #fff;
    padding: 20px 18px 25px;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    margin-bottom: 12px;
  }
  section.mini{
    padding-bottom: 10px;
  }
  section:last-child{
    margin-bottom: 0;
  }
  .caption{
    font-size: 1.6rem;
    color: #333;
    background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent;
    background-size: 12px;
    padding-left: 18px;
    margin-bottom: 15px;
    position: relative;
  }
  .cell{
    padding: 0 13px;
    font-size: 14px;
  }
  .cell .title{
    color: #666;
    /*font-size: 10px;*/
    font-size: 12px;
  }
  .cell .value{
    color: #666;
  }
  /*.cell >>> .ivu-row{*/
    /*margin-bottom: 10px;*/
  /*}*/
  .cell >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
.part2, .part3{
  margin-top: 15px;
  margin-bottom: 30px;
  position: relative;
}
.part3{
  margin-bottom: 6px;
}
.part2 .fjgz, .part3 .danzen{
  width: 50%;
  padding-right: 15px;
  padding-left: 4px;
}
.part2 .fjgz_wrap, .part3 .danzen_wrap{
  padding: 18px;
}
.part2 .ysgz, .part3 .news{
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  padding-left: 15px;
  padding-right: 4px;
}
.part2 .ysgz_wrap, .part3 .news-wrap{
  padding: 18px 18px 16px;
  height: 100%;
  position: relative;
}
.part2 .ysgz_wrap .cell, .part3 .news .cell{
  position: absolute;
  top: 58px;
  bottom: 18px;
  left: 18px;
  right: 6px;
  overflow-x: hidden;
  padding-right: 18px;
  overflow-y: auto;
}
.part2 .simple-text{
  font-size: 15px;
}
.part2 .fjgz >>> .ivu-collapse{
  background-color: #fff;
  border: 0 none;
}
.part2 .fjgz >>> .ivu-collapse>.ivu-collapse-item{
  border-color: #ccc;
}
.part2 .fjgz >>> .ivu-collapse>.ivu-collapse-item:last-child{
  border-bottom: 1px solid #ccc;
}
.part2 .fjgz >>> .ivu-collapse-header{
  padding-right: 36px;
  background: url("~@/assets/images/home/rl.png") 14px 14px no-repeat transparent;
  background-size: 10px;
}
.part2 .fjgz >>> .ivu-collapse-header .prop_name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.part2 .fjgz >>> .ivu-collapse-header .ivu-icon{
  position: absolute;
  right: 20px;
  top: 15px;
  width: 14px;
  height: 14px;
  background: url("~@/assets/images/home/ar11.png") 0 0 no-repeat transparent;
  background-size: 11px;
}
.part2 .fjgz >>> .ivu-collapse-content-box{
  padding-top: 5px;
}
.part2 .fjgz >>> .ivu-collapse-content-box p{
  line-height: 24px;
  background-color: #f5f5f2;
  padding: 4px 8px;
  border-radius: 3px;
}
.part2 .fjgz >>> .ivu-collapse-header .ivu-icon::before{
  content: "";
}
.part3 .news .more{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding-right: 10px;
  font-size: 13px;
  cursor: pointer;
}
.part3 .news .more:hover{
  color: #0470e3;
}
.scrolly::-webkit-scrollbar-track-piece {
  background: transparent;
}
.scrolly::-webkit-scrollbar {
  width: 4px;
}
.scrolly::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
.nodata{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
  font-size: 14px;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/query/RulesContent.vue